/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const headerNavBarDropMenuItemSX = ({ isParent }: { isParent: boolean }): SxProps => ({
	fontSize:16,
	fontWeight: isParent ? 600 : '',
	mt: isParent ? 1 : '',
	py: globalBreak({mobile:0.5, desktop:1}),
	px:0,
	display: 'flex',
	columnGap:'10px',
	justifyContent:'space-between',
	alignItems:'center',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	color: 'text.primary',
	'&:hover':{
		textDecoration:'underline'
	},
	'@media (hover: hover)': {
		'&:hover': {
			color: 'primary.main',
			backgroundColor: 'transparent',
		},
	},
	'@media (hover: none)': {
		'&:focus': {
			color: 'inherit',
			backgroundColor: 'inherit',
		},
	},
	"& > svg":{
		fontSize:12
	}
});

export const headerFlyoutMenuItemLabelSX: SxProps = {
	textAlign:'left',
	whiteSpace:'break-spaces',
	minWidth:globalBreak({desktop:'15vw',desktopL:'10vw', desktopXL:'10vw'}),
	fontSize:'16px !important',
}
